<div  [class]="{'disableWrapper': !isUserAutoRebalanceEnabled || isActBlockAutoSchd} " (mouseenter)="mouseHover(true)" (mouseleave)="mouseHover(false)">
  @if (showDisabledTextMessage) {
    <div style="background-color:#FFFFFFF0; position:absolute; width:100%; height:100%;z-index:101; text-align:center;">
      <div class="automationOverlay" [class]="{'disabled': !autoRebalanceDetails.isAutoRebalEnabled}">{{automatedRebalanceDisabledMessage}}</div>
    </div>
  }
  @if (data.isAutoRebalEnabled && selectedModel.allowAutoRebalOnModelUpdate === 'Paused for review') {
    <div class="block  status-message-model warning">
      <div>
        No automated rebalances can be completed while the assigned model is paused for review. &nbsp; <a class="nav-link-text" (click)="viewPortfolioModel()">Go to Model <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></a>
      </div>
    </div>
    <hr style="border-top: solid 1px #cccccc;border-bottom: none;margin-bottom:12px;">
  }
  @if (data.isAutoRebalEnabled && selectedModel.allowAutoRebalOnModelUpdate === 'Not allowed') {
    <div class="block  status-message-model warning">
      <div>
        No automated rebalances can be completed until the assigned model is set to allow automated rebalancing. &nbsp; <a class="nav-link-text" (click)="viewPortfolioModel()">Go to Model <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></a>
      </div>
    </div>
    <hr style="border-top: solid 1px #cccccc;border-bottom: none;margin-bottom:12px;">
  }
  @if (data.isAutoRebalEnabled && !(data?.isAutoRebalEdited) && selectedModel.allowAutoRebalOnModelUpdate !== 'Not allowed' && selectedModel.allowAutoRebalOnModelUpdate !== 'Paused for review') {
    @if (autoRebalNextRunDate && autoRebalanceDetails?.autoScheduler?.isActive) {
      <div class="block  status-message" >
        <div>
          The next automated rebalance will run on {{autoRebalNextRunDate}}.&nbsp;
          {{autoRebalanceDetails?.autoScheduler?.endDateType ==='End after # occurrences' ?
          ('The schedule will end after ' + (autoRebalanceDetails?.autoScheduler?.endAfterNTimes - completedRunTime).toString() + ' rebalances') :
          ''}}
          {{autoRebalanceDetails?.autoScheduler?.endDateType ==='End by (date)' && automationEndDate ?
          ('The schedule will end on ' + automationEndDate + '.') :
          ''}}
        </div>
      </div>
      <hr style="border-top: solid 1px #cccccc;border-bottom: none;margin-bottom:12px;">
    }
    @if (!(autoRebalNextRunDate && autoRebalanceDetails?.autoScheduler?.isActive)) {
      <div class="block  expired-message">The previously scheduled automated rebalance ended{{automationEndDate ? ' on ' + automationEndDate :''}}.
        <span (click)="showHistory()"><a>View Automated rebalance history</a></span>
      </div>
      <hr style="border-top: solid 1px #cccccc;border-bottom: none;margin-bottom:12px;">
    }
  }
  <div>
    @if (!multipleporfolios) {
      <div class="sliderbox left">
        <span><strong>Enable </strong></span>
        <span class="mat-slide-toggle-container"><mat-slide-toggle [checked]="autoRebalanceDetails.isAutoRebalEnabled"
          (change)="onAutoRebalanceEnabledChange($event)" [disabled]="!isUserAutoRebalanceEnabled || !autoRebalanceDetails.isAutoRebalEnabled && isActBlockAutoSchd"
        [class]="{'indeterminate': enableAutomation === null}"></mat-slide-toggle>
      </span>
    </div>
  }
  @if (multipleporfolios) {
    <div class="sliderbox left">
      <span class="left" style="line-height: 22px; margin-right: 10px;"><strong>Enable </strong></span>
      <div class="left">
        <p-radioButton class="automationEnableRadio" name="AutomationGroup" value="1" [(ngModel)]="enableAutomation"
          (ngModelChange)="onChangeAutoEnable()" [disabled]="!isUserAutoRebalanceEnabled || isActBlockAutoSchd"
        inputId="caritem1"></p-radioButton>
        <label for="caritem1" style="margin-right:5px;">Yes</label>
      </div>
      <div class="left">
        <p-radioButton class="automationEnableRadio" name="AutomationGroup" value="0" [(ngModel)]="enableAutomation"
          (ngModelChange)="onChangeAutoDisable()" [disabled]="!isUserAutoRebalanceEnabled || isActBlockAutoSchd"
        inputId="caritem2"></p-radioButton>
        <label for="caritem2">No</label>
      </div>
    </div>
  }
  @if (autoRebalanceDetails.isAutoRebalEnabled) {
    <div class="sliderbox left">
      <span class="automationEnableLabel"><strong>Enabled on:</strong></span>
      <span class="automationEnableText"><strong>{{automationEnabledDate}}</strong></span>
      <span class="automationEnableLabel"><strong>Enabled by:</strong></span>
      <span class="automationEnableText"><strong>{{autoRebalanceDetails.autoRebalRequestedBy}}</strong></span>
    </div>
  }
</div>
<div class="clear"></div>
@if (isUserAutoRebalanceEnabled && autoRebalanceDetails.isAutoRebalEnabled && isActBlockAutoSchd) {
  <div  class="disableWrapper" (mouseenter)="mouseHover(true)" (mouseleave)="mouseHover(false)">
    @if (showDisabledTextMessageWhenAutoRebEnabled) {
      <div style="background-color:#FFFFFFF0; position:absolute; width:100%; height:100%;z-index:101; text-align:center;">
        <div class="automationOverlay disabledOverAutomationProperties">{{automatedRebalanceDisabledMessage}}</div>
      </div>
    }
  </div>
}
@if (autoRebalanceDetails.isAutoRebalEnabled) {
  <div>
    <div class="enableAutomationRow left">
      <label class="automationTypeLabel"><strong>Rebalance Type:</strong></label>
      <irb-dropdown-filter #IrbSelectedRebalanceTypeDropdown
        id="irbSelectedRebalanceTypeDropdown"
        size="28"
        hoverPanelWidth="237"
        [value]="selectedRebalanceType.value"
        (search)="setChainTypeOptionsRebalanceType($event)"
        (selection)="selectRebalanceType($event)"
        [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
      ></irb-dropdown-filter>
    </div>
  </div>
}
<div class="clear"></div>
@if (autoRebalanceDetails.isAutoRebalEnabled && ENABLE_INVCASH_AUTO && selectedRebalanceType?.value?.name === 'Invest cash only') {
  <div class="enableAutomationRow left">
    <label class="automationTypeLabel"><strong>Invest Cash:</strong></label>
    <div style="display: inline-flex; align-items: center; gap: 12px;">
      <div style="display: inline-flex; align-items: center;">
        <p-radioButton name="investCashGroup" inputId="autoInvestCashSecurities" value="{{InvestCashSetting.Securities}}"
          class="automationInvestCashRadio"
          [(ngModel)]="investCashSetting" (ngModelChange)="onInvestCashChange()"
          [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"></p-radioButton>
        <label for="autoInvestCashSecurities" style="margin-left: 4px;">Underweight positions</label><span class="tooltipIcon infoIcon" calltoaction
          [calltoactionTemplate]="investCashUnderWeightToolTipIcon"></span>
      </div>
      <div style="display: inline-flex; align-items: center;">
        <p-radioButton name="investCashGroup" inputId="autoInvestCashModelSecurities" value="{{InvestCashSetting.ModelSecurities}}"
          class="automationInvestCashRadio"
          [(ngModel)]="investCashSetting" (ngModelChange)="onInvestCashChange()"
          [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"></p-radioButton>
        <label for="autoInvestCashModelSecurities" style="margin-left: 4px;">All model positions</label><span class="tooltipIcon infoIcon" calltoaction
          [calltoactionTemplate]="investCashAllModelToolTipIcon"></span>
      </div>
    </div>
  </div>
  <ng-template #investCashUnderWeightToolTipIcon>
    <div class="tooltip-body">When cash exceeds the target, iRebal prioritizes positions that are underweight relative to the model and generates potential buy orders to move them toward their targets.</div>
  </ng-template>
  <ng-template #investCashAllModelToolTipIcon>
    <div class="tooltip-body">When cash exceeds the target, iRebal allocates it across all model positions proportionally based on their target weights.</div>
  </ng-template>
}
<div class="clear"></div>
@if (autoRebalanceDetails.isAutoRebalEnabled) {
  <hr style="border-top: solid 1px #cccccc;border-bottom: none;margin-bottom:12px;">
}
@if (autoRebalanceDetails.isAutoRebalEnabled) {
  <div class="clear">
    <div class="pattern left">
      <div class="clear">
        <span class="automationScheduleLabel left"><strong>Schedule</strong></span>
      </div>
      <div class="automationPatternRow clear" style="display: flex;flex-direction: row;align-items: center;line-height: 20px;padding-top: 15px;">
        <div class="automationPatternLabel"><strong>Repeats</strong></div>
        <div >
          <p-radioButton class="automationPatternRadio" name="AutomationGroup" value="Daily" [(ngModel)]="autoRebalanceDetails.autoScheduler.recurringFreqType"
            (ngModelChange)="onChangePattern()" [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
          inputId="caritem3"></p-radioButton>
          <label for="caritem3">Daily</label>
        </div>
        <div>
          <p-radioButton class="automationPatternRadio" name="AutomationGroup" value="Weekly" [(ngModel)]="autoRebalanceDetails.autoScheduler.recurringFreqType"
            (ngModelChange)="onChangePattern()" [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
          inputId="caritem4"></p-radioButton>
          <label for="caritem4">Weekly</label>
        </div>
        <div>
          <p-radioButton class="automationPatternRadio" name="AutomationGroup" value="Monthly" [(ngModel)]="autoRebalanceDetails.autoScheduler.recurringFreqType"
            (ngModelChange)="onChangePattern()" [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
          inputId="caritem5"></p-radioButton>
          <label for="caritem5">Monthly</label>
        </div>
      </div>
      <div class="automationPatternRow clear">
        <span class="automationFrequencyLeftLabel left"><strong>Every</strong></span>
        @if (autoRebalanceDetails.autoScheduler?.recurringFreqType === 'Daily') {
          <irb-number-text-box name="rblFrequency" class="automationFrequencyInputBox"
            [value]="autoRebalanceDetails.autoScheduler.everyNDays" min="1" max="365"
            (valueChange)="rebalanceFrequencyChange($event, 'Daily')"
            [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
            invalidRangeMessage="Please enter only numbers between 1 and 365"
            invalidMessage="Please enter only whole numbers"
            placeholder="" width="60px">
          </irb-number-text-box>
          <span class="automationFrequencyRightLabel">Day(s)</span>
        }
        @if (autoRebalanceDetails.autoScheduler?.recurringFreqType === 'Weekly') {
          <irb-number-text-box name="rblFrequency" class="automationFrequencyInputBox"
            [value]="autoRebalanceDetails.autoScheduler.everyNWeeks" min="1" max="52"
            (valueChange)="rebalanceFrequencyChange($event, 'Weekly')"
            [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
            invalidRangeMessage="Please enter only numbers between 1 and 52"
            invalidMessage="Please enter only whole numbers"
            placeholder="" width="60px">
          </irb-number-text-box>
          <span class="automationFrequencyRightLabel">Week(s)</span>
        }
        @if (autoRebalanceDetails.autoScheduler?.recurringFreqType === 'Monthly') {
          <irb-number-text-box name="rblFrequency" class="automationFrequencyInputBox"
            [value]="autoRebalanceDetails.autoScheduler.everyNMonths" min="1" max="12"
            (valueChange)="rebalanceFrequencyChange($event, 'Monthly')"
            [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
            invalidRangeMessage="Please enter only numbers between 1 and 12"
            invalidMessage="Please enter only whole numbers"
            placeholder="" width="60px">
          </irb-number-text-box>
          <span class="automationFrequencyRightLabel">Month(s)</span>
        }
      </div>
      @if (autoRebalanceDetails.autoScheduler.recurringFreqType === 'Weekly') {
        <div style="padding-top:15px;">
          <span style="width:65px;" class="left"><strong>On</strong></span>
          <div class="left weekDayDiv">
            <p-checkbox name="groupname" [value]="'M'" [(ngModel)]="autoRebalanceDetails.autoScheduler.monday"
              (onChange)="onWeekDayChange()" binary="true" [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
            inputId="caritem6"></p-checkbox>
            <label for="caritem6">Mon</label>
          </div>
          <div class="left weekDayDiv">
            <p-checkbox name="groupname" [value]="'Tu'" [(ngModel)]="autoRebalanceDetails.autoScheduler.tuesday"
              (onChange)="onWeekDayChange()" binary="true" [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
            inputId="caritem7"></p-checkbox>
            <label for="caritem7">Tue</label>
          </div>
          <div class="left weekDayDiv">
            <p-checkbox name="groupname" [value]="'W'" [(ngModel)]="autoRebalanceDetails.autoScheduler.wednesday"
              (onChange)="onWeekDayChange()" binary="true" [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
            inputId="caritem8"></p-checkbox>
            <label for="caritem8">Wed</label>
          </div>
          <div class="left weekDayDiv">
            <p-checkbox name="groupname" [value]="'Th'" [(ngModel)]="autoRebalanceDetails.autoScheduler.thursday"
              (onChange)="onWeekDayChange()" binary="true" [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
            inputId="caritem9"></p-checkbox>
            <label for="caritem9">Thu</label>
          </div>
          <div class="left weekDayDiv">
            <p-checkbox name="groupname" [value]="'F'" [(ngModel)]="autoRebalanceDetails.autoScheduler.friday"
              (onChange)="onWeekDayChange()" binary="true" [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
            inputId="caritem10"></p-checkbox>
            <label for="caritem10">Fri</label>
          </div>
        </div>
      }
      @if (autoRebalanceDetails.autoScheduler.recurringFreqType === 'Monthly') {
        <div class="left monthlySchedulerDiv clear">
          <span class="automationFrequencyLeftLabel left"><strong>On</strong></span>
          <div class="left monthlyScheduler">
            <div class="monthlySchedulerRow clear">
              <div class="monthlySchedulerSwitch left">
                <p-radioButton class="monthlySchedulerRadio" name="monthlySchedulerGroup" value="0" [(ngModel)]="monthlySchedulerOption"
                (ngModelChange)="onMonthlySchedulerSwitch()" [disabled]="!isUserAutoRebalanceEnabled || isActBlockAutoSchd"></p-radioButton>
              </div>
              <div class="left" tooltip [tooltipTitle]="endOfMonthWarning" tooltipPosition="right" tooltipClass="error">
                <irb-number-text-box style="display: block;" min="1" max="31"
                  [value]="autoRebalanceDetails.autoScheduler.dateNumber" width="50px"
                  [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled && monthlySchedulerOption==='0') || isActBlockAutoSchd"
                  invalidRangeMessage="Please enter a number between 1 and 31" (keyup)="validateDateNumberInput()"
                  (valueChange)="dateNumberChange($event)">
                </irb-number-text-box>
              </div>
              <div class="left"><span style="margin-left:15px;"> day of the month</span></div>
            </div>
            <div class="monthlySchedulerRow clear">
              <div class="monthlySchedulerSwitch left">
                <p-radioButton class="monthlySchedulerRadio" name="monthlySchedulerGroup" value="1" [(ngModel)]="monthlySchedulerOption"
                (ngModelChange)="onMonthlySchedulerSwitch()" [disabled]="!isUserAutoRebalanceEnabled || isActBlockAutoSchd"></p-radioButton>
              </div>
              <div class="left">
                <irb-dropdown-filter #IrbendDeveryMonthListDropdown class="monthlySchedulerDropDown"
                  [value]="selectedEveryMonthListOptions.value"
                  [size]="15"
                  (search)="setChainTypeEveryMonthListOptions()"
                  (selection)="monthSelection($event)"
                  [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled && monthlySchedulerOption==='1') || isActBlockAutoSchd"
                ></irb-dropdown-filter>
              </div>
              <div class="left">
                <irb-dropdown-filter #IrbendDeveryMonthWeekDayListDropdown class="monthlySchedulerWeekDayDropDown"
                  [value]="selectedEveryMonthWeekDayListOptions.value"
                  [size]="10"
                  (search)="setChainTypeEveryMonthWeekDayListOptions()"
                  (selection)="onEveryDayList($event)"
                  [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled && monthlySchedulerOption==='1') || isActBlockAutoSchd"
                ></irb-dropdown-filter>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="duration left">
      <div class="clear">
        <span class="durationLabel"><strong>Duration</strong></span>
      </div>
      <div class="durationStart">
        <span class="durationStartLabel"><strong>Starts</strong></span>
        <div class="mat-datepicker-container">
          <input class="automationStartDate"
            [class]="toolTipStartDate !== ''? 'input-not-valid' : ''"
            tooltip
            [tooltipTitle]="toolTipStartDate"
            [tooltipPosition]="'right'"
            tooltipClass="error"
            [tooltipHorizontalOffset]="8"
            [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
            [readonly]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd"
            matInput [matDatepicker]="picker1" [min]="automationStartDateValidation" class="date-control end-date"
            [matDatepickerFilter]="myFilter" [formControl]="automationStartDateControl" (dateChange)="automationStartDateChange($event)">
          <mat-datepicker-toggle [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled) || isActBlockAutoSchd" matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1 color="primary"></mat-datepicker>
        </div>
      </div>
      <div class="durationEnd left">
        <span class="durationEndLabel left"><strong>Ends</strong></span>
        <div class="endOptions left">
          <div class="endOptionsRow clear">
            <div class="endOptionSwitch left">
              <p-radioButton class="endOptionRadio" name="endOptionsGroup" value="No End Date" [(ngModel)]="autoRebalanceDetails.autoScheduler.endDateType"
              (ngModelChange)="onEndOptionSwitch()" [disabled]="!isUserAutoRebalanceEnabled || isActBlockAutoSchd"></p-radioButton>
            </div>
            <div class="left endOptionLabel"><span> Never</span></div>
          </div>
          <div class="endOptionsRow clear">
            <div class="endOptionSwitch left">
              <p-radioButton class="endOptionRadio" name="endOptionsGroup" value="End after # occurrences" [(ngModel)]="autoRebalanceDetails.autoScheduler.endDateType"
              (ngModelChange)="onEndOptionSwitch()" [disabled]="!isUserAutoRebalanceEnabled || isActBlockAutoSchd"></p-radioButton>
            </div>
            <div class="left endOptionLabel"><span> After</span></div>
            @if (endAfterNTimesReady) {
              <div class="left date-end-after-input">
                <irb-number-text-box [value]="autoRebalanceDetails.autoScheduler.endAfterNTimes"
                  [disabled]="!(this.data.isAutoRebalEnabled && isUserAutoRebalanceEnabled && autoRebalanceDetails.autoScheduler.endDateType ==='End after # occurrences') || isActBlockAutoSchd"
                  (valueChange)="endAfterNTimesChange($event)"
                  [min]="this.autoRebalanceDetails.autoScheduler.isActive ? (completedRunTime + 1) : 1" [max]="1000" width="50px"
                height="28px"></irb-number-text-box>
              </div>
            }
            @if (endAfterNTimesReady) {
              <div class="left"><span style="margin-left:15px;"> occurrences </span><span></span></div>
            }
          </div>
          <div class="endOptionsRow clear">
            <div class="endOptionSwitch left">
              <p-radioButton class="endOptionRadio" name="endOptionsGroup" value="End by (date)" [(ngModel)]="autoRebalanceDetails.autoScheduler.endDateType"
              (onClick)="onEndOptionSwitch()" [disabled]="!isUserAutoRebalanceEnabled || isActBlockAutoSchd"></p-radioButton>
            </div>
            <div class="left endOptionLabel"><span> On</span></div>
            <div class="left dateStartDateDiv">
              <div class="mat-datepicker-container">
                <input class="automationEndInputBox"
                  [class]="toolTipEndDate !== ''? 'input-not-valid' : ''"
                  tooltip
                  [tooltipTitle]="toolTipEndDate"
                  [tooltipPosition]="'right'"
                  tooltipClass="error"
                  [tooltipHorizontalOffset]="8"
                  [disabled]="!this.data.isAutoRebalEnabled || !isUserAutoRebalanceEnabled || !(autoRebalanceDetails.autoScheduler.endDateType ==='End by (date)') || isActBlockAutoSchd"
                  [readonly]="!this.data.isAutoRebalEnabled || !isUserAutoRebalanceEnabled || !(autoRebalanceDetails.autoScheduler.endDateType ==='End by (date)') || isActBlockAutoSchd"
                  matInput [matDatepicker]="picker2" [min]="endDateMinValidation" class="date-control end-date"
                  [matDatepickerFilter]="myFilter" [formControl]="schedulerEndByDate" (dateChange)="endDateChange($event)">
                <mat-datepicker-toggle [disabled]="!this.data.isAutoRebalEnabled || !isUserAutoRebalanceEnabled || !(autoRebalanceDetails.autoScheduler.endDateType ==='End by (date)') || isActBlockAutoSchd" matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2 color="primary">
                </mat-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
</div>
<div class="clear"></div>
<!--<ng-container *ngIf="autoRebalNextRunDate && autoRebalanceDetails?.autoScheduler?.isActive">-->
<!--    <hr style="border-top: solid 1px #cccccc;border-bottom: none;margin-bottom:12px;">-->
<!--    <div class="block  status-message">-->
<!--        The next automated rebalance will run on {{autoRebalNextRunDate}}.&nbsp;-->
<!--        {{autoRebalanceDetails?.autoScheduler?.endDateType ==='End after # occurrences' ?-->
<!--        ('The schedule will end after ' + (autoRebalanceDetails?.autoScheduler?.endAfterNTimes - completedRunTime).toString() + ' rebalances') :-->
<!--        ''}}-->
<!--        {{autoRebalanceDetails?.autoScheduler?.endDateType ==='End by (date)' && automationEndDate ?-->
<!--        ('The schedule will end on ' + automationEndDate + '.') :-->
<!--        ''}}-->
<!--    </div>-->
<!--</ng-container>-->
@if (!multipleporfolios) {
  <div style="position:relative; z-index:110;">
    <hr style="border-top: solid 1px #cccccc;border-bottom: none;margin-bottom:12px;">
    <p><span><strong>Automated Rebalance History</strong></span>&nbsp;&nbsp;
    @if (!isShowHistory) {
      <span class="bold" (click)="showHistory()"><a>Show</a> / Hide </span>
    }
    @if (isShowHistory) {
      <span class="bold" (click)="hideHistory()">Show / <a>Hide</a></span>
    }
  </p>
  @if (!isUiTest && isShowHistory && !multipleporfolios) {
    <irb-inventory-grid
      [style.width]="'100%'"
      [gridHeight]="historyGridHeight"
      [domLayout]="historyGridDomLayout"
      [showSideBar]="false"
      [gridOptions]="gridOptions"
      [frameworkComponents]="frameworkComponents"
    (gridReady)="onGridReady($event)"></irb-inventory-grid>
  }
</div>
}
